import { useMemo, type ReactNode } from "react";
import { barChartSpec, type BarChartSpecOptions } from "../specs/bar.js";
import type { ChartData } from "../types.js";
import { VegaChart } from "./VegaChart.js";
import type { ChartContainerProps } from "./shared.js";

export interface BarChartProps
  extends BarChartSpecOptions, ChartContainerProps {
  data: ChartData;
}

/** A themed bar chart. Pass `color` to split into a grouped/stacked series. */
export function BarChart({
  data,
  x,
  y,
  xType,
  yType,
  color,
  colorType,
  horizontal,
  stack,
  xTitle,
  yTitle,
  title,
  subtitle,
  ...container
}: BarChartProps): ReactNode {
  const spec = useMemo(
    () =>
      barChartSpec({
        data,
        x,
        y,
        xType,
        yType,
        color,
        colorType,
        horizontal,
        stack,
        xTitle,
        yTitle,
        title,
        subtitle,
      }),
    [
      data,
      x,
      y,
      xType,
      yType,
      color,
      colorType,
      horizontal,
      stack,
      xTitle,
      yTitle,
      title,
      subtitle,
    ],
  );

  return <VegaChart spec={spec} {...container} />;
}
